export default __webpack_public_path__ + "static/media/bus_icon_black.8a74cef4.png";